import styled from 'styled-components'
import { Section } from 'src/components/Layout/Section/Section'

export const SearchTableSection = styled(Section)`
    td p {
        white-space: normal;
    }
`
